import React, { useEffect } from 'react';
import Header from '@components/ui/Header';
import HeroSection from './components/HeroSection';
import Footer from '@components/ui/Footer';
import FounderJourney from './components/FounderJourney';
import MissionVisionSection from './components/MissionVisionSection';
import MedicalPhilosophy from './components/MedicalPhilosophy';
import CommunityImpact from './components/CommunityImpact';
import TeamIntroduction from './components/TeamIntroduction';
import InternationalCredentials from './components/InternationalCredentials';
import VisionForFuture from './components/VisionForFuture';

const AboutPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Update document title
    document.title = 'About - Our Story & Medical Philosophy | Eye&U Kenya';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Discover Eye&U Kenya\'s journey from international training to transforming eye care across East Africa. Learn about our medical philosophy, community impact, and vision for the future.'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="w-full">
        {/* Hero Section - Our Story Introduction */}
        <HeroSection />

        {/* Founder Journey - Personal story and timeline */}
        <FounderJourney />

        <MissionVisionSection />

        {/* Team Introduction - Leading to full team page */}
        <TeamIntroduction />

        {/* Medical Philosophy - Ubuntu-centered care and cultural sensitivity */}
        <MedicalPhilosophy />
        
        {/* Community Impact - Statistics and programs 
        <CommunityImpact />
        
        {/* International Credentials - Global standards and partnerships 
        <InternationalCredentials /> */}
        
        {/* Vision for Future - East Africa transformation goals */}
        <VisionForFuture />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;